import { LINE_LEGEND_PLUGIN } from "services/charts/plugins/legend"

export const DEFAULT_PLUGINS = [LINE_LEGEND_PLUGIN]
